// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__c8uhB","loading":"Notification_loading__s31B2","success":"Notification_success__QNYEw","error":"Notification_error__Bvpds"};